import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './Login.css';

function ForgotPassword() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Fehler beim Senden.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-title">
            <span className="logo-strix">Strix</span><span className="logo-ly">ly</span>
          </div>
          <p>Passwort zurücksetzen</p>
        </div>

        {error && <div className="error-message fade-in">{error}</div>}

        {sent ? (
          <div className="verify-info fade-in">
            <div className="verify-icon">📧</div>
            <h3>E-Mail gesendet</h3>
            <p>Falls ein Konto mit dieser Adresse existiert, haben wir einen Reset-Link gesendet. Bitte prüfe dein Postfach.</p>
            <Link to="/login" className="btn btn-secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>
              Zurück zum Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">E-Mail-Adresse</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="deine@email.de"
                required
                autoFocus
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading || !email}>
              {loading ? 'Sende…' : 'Reset-Link senden'}
            </button>
            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <Link to="/login" style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                Zurück zum Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
